import {
   HealthcareFacilityPart,
   HealthcareFacilityPartForCurrentOrganizationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';

export const healthcareFacilityPartForCurrentOrganizationSearchCreator = () => {
   return async (): CqrsQueryPerformResult<HealthcareFacilityPart[]> =>
      performCqrsQuerySearch<HealthcareFacilityPart>(() => {
         return new HealthcareFacilityPartForCurrentOrganizationQuery();
      });
};
